import { gql } from "@apollo/client";

export const imagesAdminQuery = gql`
    query ImagesAdmin($cameraId: ID!, $page: Int, $size: Int, $sort: SortInput) {
        imagesAdmin(cameraId: $cameraId, page: $page, size: $size, sort: $sort) {
            nodes {
                id
                mailedAt
            }
            totalCount
            totalPages
            nextPage
            previousPage
        }
    }
`;
